import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_Ozo_Badge_Bar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  return (
    <Row className={"mx-0"} style={{ height: Number(item.height) }}>
      <div style={{ backgroundColor: "#fff" }}>
        {/* Sub scope name if exists */}
        {isSub && item.scopeName && (
          <Row className={"_detail-section-sub-scope-name-header-pdf mb-2"}>{item.scopeName}</Row>
        )}

        {/* Main horizontal layout */}
        <Row className="align-items-center">
          {/* Title - Left */}
          <Col xs="3">
            <div
              className={isSub ? "_detail-section-sub-scope-name-header-pdf" : "_detail-section-scope-name-header-pdf"}
              style={{ fontSize: "16px", fontWeight: "600", whiteSpace: "nowrap", color: "#092441", textAlign: "left" }}
            >
              {item.name}
            </div>
          </Col>

          {/* Progress bar - Center */}
          <Col xs="auto" style={{ width: "150px", padding: "0" }}>
            <Row className={"mx-0 w-100"}>
              <Col xs={"auto"} className={"align-content-center px-0"}>
                <div className={"fw-medium lh-1 text-color-gray-dark"} style={{ fontSize: "16px" }}>
                  {elementScore}%
                </div>
              </Col>
              <Col className={"px-2"}>
                <div
                  style={{
                    borderRadius: "9px",
                    background: "linear-gradient(270deg, rgba(160, 228, 234, 0.2) 0%, rgba(0, 234, 255, 0.2) 100%)",
                  }}
                >
                  <Row className={"mx-0"} style={{ height: "18px" }}>
                    <Col
                      xs={"auto"}
                      className={"px-0"}
                      style={{
                        borderRadius: "9px",
                        minWidth: "18px",
                        width: `${elementScore}%`,
                        background: "linear-gradient(270deg, #A0E4EA 0%, #00EAFF 100%)",
                      }}
                    ></Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>

          {/* General information text - Right */}
          <Col>
            {item.generalInformationText?.length > 2 && (
              <div
                className="_detail-scale-general-info-text-pdf pt-3"
                style={{ fontSize: "10px", color: "#666", lineHeight: "1.1", textAlign: "justify" }}
                dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
              />
            )}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
